import React from 'react';
import "../style/AppPages.css"
import { Trans, useTranslation } from 'react-i18next';

const TermsOfSale = () => {
    const { t } = useTranslation();

    return (
        <div class="page-padding-info">
            
            <div class="text-page-container">
                <h1 class="text-page-title">{t("termsOfSale.title")}</h1>

                <strong>{t("privacyPolicy.introTitle")}</strong>
                <p>
                    {t("termsOfSale.welcome")}
                    <br></br>
                    {t("termsOfSale.intro1")}
                    <br></br>
                    <br></br>
                    <Trans i18nKey="termsOfSale.intro2" components={{ 1: <strong />, 2: <a href="/terms-of-service" class="no-link-color" />, 3: <a href="/privacy-policy" class="no-link-color" /> }} />
                    <br></br>
                    <br></br>
                    {t("termsOfSale.intro3")}
                    <br></br>
                    <br></br>
                    {t("termsOfSale.intro4")}
                </p>

                <strong>{t("termsOfSale.definitionTitle")}</strong>
                <div style={{ marginLeft: "2rem" }}>
                    <ul>
                        <li>
                            <p>
                                <strong>
                                    {t("termsOfSale.usTitle")} : 
                                </strong>
                                &nbsp;
                               {t("termsOfSale.usText")}
                            </p>
                        </li>
                        <li>
                            <p>
                                <strong>
                                    {t("termsOfSale.productsTitle")} :
                                </strong>
                                &nbsp;
                                {t("termsOfSale.productsText")}
                            </p>
                        </li>
                        <li>
                            <p>
                                <strong>
                                    {t("termsOfSale.userTitle")} : 
                                </strong>
                                &nbsp;
                                {t("termsOfSale.userText")}
                            </p>
                        </li>
                        <li>
                            <p>
                                <strong>
                                    {t("termsOfSale.paymentTitle")} : 
                                </strong>
                                &nbsp;
                                {t("termsOfSale.paymentText")}
                            </p>
                        </li>
                        <li>
                            <p>
                                <strong>
                                    {t("termsOfSale.returnsTitle")} : 
                                </strong>
                                &nbsp;
                                {t("termsOfSale.returnsText")}
                            </p>
                        </li>
                    </ul>
                </div>
                
                <br />

                <strong>{t("termsOfSale.prodAvailabilityTitle")}</strong>
                <p>
                    {t("termsOfSale.prodAvailabilityText")}
                </p>

                <strong>{t("termsOfSale.manufacturingTitle")}</strong>
                <p>
                    {t("termsOfSale.manufacturingText")}
                </p>

                <strong>{t("termsOfSale.deliveryTitle")}</strong>
                <p>
                {t("termsOfSale.deliveryText1")}
                    <br></br>
                    <br></br>
                    {t("termsOfSale.deliveryText2")}
                    <br></br>
                    <br></br>
                    {t("termsOfSale.deliveryText3")}
                    <br></br>
                    <br></br>
                    {t("termsOfSale.deliveryText4")}
                    <br></br>
                    <br></br>
                    {t("termsOfSale.deliveryText5")}
                </p>

                <strong>{t("termsOfSale.returnCancelTitle")}</strong>
                <p>
                    {t("termsOfSale.returnCancelText1")}
                    <br></br>
                    <br></br>
                    {t("termsOfSale.returnCancelText2")}
                    <br></br>
                    <br></br>
                    {t("termsOfSale.returnCancelText3")}
                    <br></br>
                    <br></br>
                    <Trans i18nKey="termsOfSale.returnCancelText4" components={{ 1: <br /> }} />
                </p>

                <strong>{t("privacyPolicy.contactTitle")}</strong>
                <p>
                    <Trans i18nKey="termsOfSale.privacyPolicyText" components={{ 1: <a href="mailto:contact@awootoys.com" /> }} />
                </p>

                <br />
                <strong>{t("privacyPolicy.ourAddressTitle")}</strong>
                <p>
                    <Trans i18nKey="privacyPolicy.ourAddress" components={{ 1: <a href="mailto:contact@awootoys.com" />, 2: <br />, 3: <strong /> }} />
                </p>
            </div>
        </div>
    );
}

export default TermsOfSale;